import { render, staticRenderFns } from "./DialogoPublicidad.vue?vue&type=template&id=8d400904&scoped=true"
import script from "./DialogoPublicidad.vue?vue&type=script&lang=js"
export * from "./DialogoPublicidad.vue?vue&type=script&lang=js"
import style0 from "./DialogoPublicidad.vue?vue&type=style&index=0&id=8d400904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d400904",
  null
  
)

export default component.exports